import React, { useEffect, useState } from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import API from '../Services/Card'
import moment from "moment";
import CardPriceList from "../Components/CardPriceList";


const CardPrice = () => {
    const [amount, setAmount] = useState("")
    const [error, setError] = useState({});
    const [currentPage, setCurrentPage] = useState(1);
    const [type, setType] = useState("");
    const [id, setId] = useState([])

    useEffect(() => {
    }, [currentPage])


    const handleFieldChange = (e, fieldName) => {
        const value = e.target.value;
        if (value.trim()) {
            setError((prevErrors) => {
                const updatedErrors = { ...(prevErrors || {}) };
                delete updatedErrors[fieldName];
                return updatedErrors;
            });
        }
        switch (fieldName) {
            case "amount":
                setAmount(value);
                break;
            case "type":
                setType(value);
                break;
            default:
                break;
        }
    };

    const validateFields = () => {
        const errors = {};
        if (!amount.trim()) {
            errors.amount = "Amount is required";
        } else if (!/^\d+$/.test(amount.trim())) {
            errors.amount = "Amount must be numeric only";
        }
        if (!type?.trim()) errors.type = "Type is required";
        setError(errors);
        return Object.keys(errors).length === 0;
    };

    const saveCardData = async () => {
        const payload = {
            type: type,
            price: amount
        }
        try {
            const response = await API.saveCard(payload)
           // console.log("reponse data...", response?.data?.data)
            if (response?.status === 201) {
                toast.success(response?.data?.message || "Card price created successfully!");
                setTimeout(() => window.location.reload(), 2000);
            } else {
                toast.error(response?.data?.message || "Failed to card price");
            }
        } catch (error) {
            if (error.response?.status === 403) {
                window.location.replace("/Login");
            }
            toast.error(error.message);
        }

    }

    const handleSubmit = async () => {
        if (!validateFields()) return;
        saveCardData()
    }
    const handleCancel = () => {
        setId("")
        setAmount("")
        setType("")
    }
    return (
        <div>
            <div >
                <div className="col-12 grid-margin stretch-card">
                    <div className="card">
                        <div className="card-body">
                            <div className="forms-sample">
                                <div className="row">
                                    <div className="col-md-6">
                                        <div className="form-group">
                                            <label htmlFor="name">Card Amount <span style={{ color: "red" }}>*</span></label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                id="txtreason"
                                                placeholder="Enter Amount"
                                                value={amount}
                                                onChange={(e) => handleFieldChange(e, "amount")}

                                            />
                                            {error?.amount && (
                                                <span className="text-danger" style={{ fontSize: "12px" }}>
                                                    {error.amount}
                                                </span>
                                            )}
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="form-group">
                                            <label>
                                                Type <span style={{ color: "red" }}>*</span>
                                            </label>
                                            <select
                                                className="form-select"
                                                value={type}
                                                onChange={(e) => handleFieldChange(e, "type")}
                                            >

                                                <option value="">Select Type</option>
                                                <option value="new_card">New Card</option>
                                                <option value="reIssuecard">Re Issue Card</option>
                                            </select>
                                            {error?.type && <span className="text-danger" style={{ fontSize: "12px" }}>{error.type}</span>}
                                        </div>
                                    </div>
                                </div>
                                <div className="mt-3">
                                    <button
                                        onClick={handleSubmit}
                                        type="submit"
                                        className="btn btn-primary">
                                        Submit
                                    </button>
                                    <button onClick={handleCancel} className="btn btn-light ms-2">Cancel</button>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
            <ToastContainer />
            <CardPriceList />
        </div>

    );
};

export default CardPrice;